import React, { useState } from 'react';
import { BarChart3, DollarSign, ChevronRight, TrendingUp } from 'lucide-react';
import PaymentAnalysis from './PaymentAnalysis';
import AccountTracking from './AccountTracking';
import RecurringPaymentsAnalysis from './RecurringPaymentsAnalysis';
import { useTranslation } from '../lib/i18n';

const Panels = () => {
  const { t } = useTranslation();
  const [activePanel, setActivePanel] = useState('payment-analysis');

  const panels = [
    {
      id: 'payment-analysis',
      name: 'panels.paymentAnalysis',
      icon: BarChart3,
      component: PaymentAnalysis
    },
    {
      id: 'recurring-payments-analysis',
      name: 'panels.recurringPaymentsAnalysis',
      icon: TrendingUp,
      component: RecurringPaymentsAnalysis
    },
    {
      id: 'account-tracking',
      name: 'menu.accountTracking',
      icon: DollarSign,
      component: AccountTracking
    }
  ];

  const ActiveComponent = panels.find(p => p.id === activePanel)?.component || PaymentAnalysis;

  return (
    <div className="flex flex-col lg:flex-row h-full bg-gray-50 dark:bg-gray-900" style={{ height: 'calc(100vh - 0px)' }}>
      {/* Sol Panel Menü - Mobilde üstte, desktop'ta solda */}
      <div className="w-full lg:w-64 bg-white dark:bg-gray-800 border-b lg:border-b-0 lg:border-r border-gray-200 dark:border-gray-700 shadow-sm flex-shrink-0">
        <div className="p-4 lg:p-6 border-b border-gray-200 dark:border-gray-700">
          <h2 className="text-lg lg:text-xl font-bold text-gray-900 dark:text-white">{t('panels.title')}</h2>
          <p className="text-xs lg:text-sm text-gray-500 dark:text-gray-400 mt-1">{t('panels.subtitle')}</p>
        </div>
        
        <nav className="p-2 lg:p-4 space-y-2 overflow-x-auto lg:overflow-y-auto flex lg:flex-col flex-row" style={{ maxHeight: 'calc(100vh - 120px)' }}>
          {panels.map((panel) => {
            const Icon = panel.icon;
            const isActive = activePanel === panel.id;
            
            return (
              <button
                key={panel.id}
                onClick={() => setActivePanel(panel.id)}
                className={`flex-shrink-0 lg:w-full flex items-center justify-between px-3 lg:px-4 py-2 lg:py-3 rounded-lg transition-all duration-200 whitespace-nowrap ${
                  isActive
                    ? 'bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 border border-blue-200 dark:border-blue-700'
                    : 'text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 hover:text-gray-900 dark:hover:text-white'
                }`}
              >
                <div className="flex items-center space-x-2 lg:space-x-3">
                  <Icon className={`h-4 w-4 lg:h-5 lg:w-5 ${isActive ? 'text-blue-600 dark:text-blue-400' : 'text-gray-400 dark:text-gray-500'}`} />
                  <span className="font-medium text-sm lg:text-base">{t(panel.name)}</span>
                </div>
                {isActive && (
                  <ChevronRight className="h-3 w-3 lg:h-4 lg:w-4 text-blue-600 dark:text-blue-400 ml-2" />
                )}
              </button>
            );
          })}
        </nav>
      </div>

      {/* Sağ Panel İçerik */}
      <div className="flex-1 overflow-auto bg-gray-50 dark:bg-gray-900 min-w-0">
        <ActiveComponent />
      </div>
    </div>
  );
};

export default Panels;

